// NPM packages
import React from 'react';
import { styled } from '@mui/system';

// All other imports
import PageContent from 'components/core/PageContent';
import Link from 'components/core/Link';

const Root = styled('div')({
  fontFamily: "'Roboto', sans-serif",
  fontSize: '1.125rem',
  lineHeight: 1.6,
  maxWidth: '820px',
  margin: '0 auto',
  padding: '2rem 1rem',
});

const Title = styled('h1')({
  fontFamily: "'Rubik', 'Roboto', sans-serif",
  fontSize: '3rem',
  fontWeight: 700,
  marginBottom: '1.5rem',
});

const Paragraph = styled('p')({
  marginBottom: '1.25rem',
});

const SampleAckBlockquote = styled('blockquote')(({ theme: { palette } }) => ({
  borderLeft: `4px solid ${palette.primary.main}`,
  margin: '1.5rem 0',
  padding: '0.75rem 1.25rem',
  background: '#f4f6fa',
  fontStyle: 'italic',
  color: '#333',
}));

export default function Acknowledgement(): React.ReactElement {
  return (
    <PageContent>
      <Root>
        <Title>Acknowledgement</Title>
        <Paragraph>
          Please acknowledge in your publications the role MSD-LIVE played in
          your research. Also, please let us know{' '}
          (<Link to="mailto:info@msdlive.org">info@msdlive.org</Link>) when a
          paper that utilizes MSD-LIVE resources is accepted or close to
          publication, as we may highlight it on our site.
        </Paragraph>

        <Paragraph>A sample acknowledgement:</Paragraph>

        <SampleAckBlockquote>
          This paper leverages the capabilities of the MultiSector Dynamics –
          Living, Intuitive, Value-adding, Environment (MSD-LIVE) platform
          funded by U.S. Department of Energy, Office of Science. MSD-LIVE,{' '}
          <Link to="https://msdlive.org" openNewTab>
            https://msdlive.org
          </Link>
          , was developed and is maintained by Pacific Northwest National
          Laboratory.
        </SampleAckBlockquote>
      </Root>
    </PageContent>
  );
}